// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"13bf465c","84":"171d5250","668":"d67cee6d","925":"a8ae4976"}[chunkId] + ".css";
};